import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
  getServiceProviderProfile,
  updateServiceProviderProfile,
  addServiceProvider,
  setErrorServiceProviderProfile,
  getServiceProviderData,
  setServiceProviderData,
  setDateServiceProvider,
  setResultServiceProvider
} from "../../../../store/service-provider/actions";
import ServiceProviderInformationForm from "../AddServiceProvider/components/ServiceProviderInformationForm";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';
import {
  Button, Card, CardBody, Col, Container, Row,
  Nav,
  NavItem,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import ServiceProviderDashboard from "../AddServiceProvider/components/ServiceProviderDashboard";

const DEFAULT_WIDGET = [
  {
    icon: "bx bx-wallet-alt",
    title: "Payment",
    value: 0,
  },
  {
    icon: "bx bx-money",
    title: "Cost",
    value: 0,
  },
  {
    icon: "mdi mdi-cash-plus",
    title: "Cashback",
    value: 0,
  },
];

class ServiceProvidersProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "detail",
    };
  }

  componentDidMount() {
    const location = this.props.history.location;
    const hash = location.hash.split("#").join("") || "detail";
    this.toggle(hash);
    this.props.getServiceProviderProfile(this.props.match.params.serviceProviderId);
    this.props.getServiceProviderData({
      service_provider_id: this.props.match.params.serviceProviderId,
      date_from: this.props.defDate.start_date,
      date_to: this.props.defDate.end_date,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.hash !== this.props.location.hash) {
      this.handleUpdateTab();
    }
  }

  componentWillUnmount() {
    let date = new Date();
    this.props.setDateServiceProvider({
      start_date: new Date(date.getFullYear(), date.getMonth(), 1 + 1)
        .toJSON()
        .split("T")[0],
      end_date: new Date(date.getFullYear(), date.getMonth() + 1, 0 + 1)
        .toJSON()
        .split("T")[0],
    });
    this.props.setServiceProviderData(DEFAULT_WIDGET)
    this.props.setResultServiceProvider({ results: [] })
    this.props.setErrorServiceProviderProfile(false);
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "detail";
    this.toggle(hash)
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  onFiltersChange = (filters, type, status) => {
    const { start_date, end_date } = this.props.defDate;

    let days = {
      start_date: filters.start_date || start_date,
      end_date: filters.end_date || end_date,
    };

    this.setState({
      activeFilters: {
        ...filters,
        ...days,
      },
    });

    if (type != "permit") {
      this.props.getServiceProviderData({
        service_provider_id: this.props.match.params.serviceProviderId,
        date_from: days.start_date,
        date_to: days.end_date,
      })
    }
  };

  handleDateRangeChange = filterDate => {
    // let prevHistory = queryString.parse(this.props.history.location.search);
    let days = {
      start_date: filterDate.start_date,
      end_date: filterDate.end_date,
    };

    let dt = {
      // ...prevHistory,
      ...this.state.activeFilters,
      start_date: filterDate.start_date,
      end_date: filterDate.end_date,
    };

    if (dt?.start_date && dt?.end_date) {
    //   let formQueryString = queryString.stringify(
    //     Object.assign(prevHistory, {
    //       ...days,
    //     })
    //   );

      // this.props.history.push({ search: formQueryString, hash: this.props.location.hash.split("#").join("") || "detail" });
      return this.props.setDateServiceProvider(dt);
    }
  };

  changeTable = (data) => {
    console.log(data)
  }

  render() {
    const {
      data,
      contactData,
      isError,
      history,
      addServiceProvider,
      updateServiceProviderProfile,
      profileLoader,
      permissions,
      serviceData,
      serviceLoader,
      defDate,
      serviceProviderStats
    } = this.props;

    if (isError) {
      return <Redirect to={"/404"} />;
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Service provider profile | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Service providers"
              breadcrumbItem={data?.contract_number}
              link="/service-providers"
            />

            <Row>
              <Col sm="col-12">
                <Card className="mb-0">
                  <CardBody>
                    <Nav
                      tabs
                      className="nav-tabs-custom"
                      style={{
                        width: "80%",
                        borderBottom: "0",
                      }}
                    >
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "detail",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "detail",
                          })}
                          onClick={() => {
                            this.toggle("detail");
                          }}
                        >
                          Detail
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "dashboard",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "dashboard",
                          })}
                          onClick={() => {
                            this.toggle("dashboard");
                          }}
                        >
                          Dashboard
                        </Link>
                      </NavItem>
                    </Nav>
                  </CardBody>
                </Card>
              </Col>
            </Row>


          </Container>

          <TabContent
            activeTab={this.state.activeTab}
            className="text-muted"
            style={{ padding: "40px 12px 0px 12px" }}
          >
            <TabPane tabId="detail">
              <Row>
                <Col className="col-12">
                  <ServiceProviderInformationForm
                    data={data}
                    contactData={contactData}
                    history={history}
                    addServiceProvider={addServiceProvider}
                    updateServiceProviderProfile={updateServiceProviderProfile}
                    serviceProviderId={this.props.match.params.serviceProviderId}
                    loader={profileLoader}
                    permissions={permissions}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="dashboard">
              <Row>
                <Col className="col-12">
                  <ServiceProviderDashboard
                    table_data={serviceProviderStats}
                    history={history}
                    serviceData={serviceData}
                    serviceLoader={serviceLoader}
                    permissions={permissions}
                    handleDateRangeChange={this.handleDateRangeChange}
                    onFiltersChange={this.onFiltersChange}
                    handleTableChange={this.changeTable}
                    defDate={defDate}
                  />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
}

ServiceProvidersProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      serviceProviderId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  contactData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  data: PropTypes.object.isRequired,
  isError: PropTypes.any,
  serviceProviderStats: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  profileLoader: PropTypes.bool.isRequired,
  getServiceProviderProfile: PropTypes.func.isRequired,
  updateServiceProviderProfile: PropTypes.func.isRequired,
  addServiceProvider: PropTypes.func.isRequired,
  setErrorServiceProviderProfile: PropTypes.func.isRequired,
  permissions: PropTypes.any,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  serviceData: PropTypes.array,
  serviceLoader: PropTypes.bool,
  getServiceProviderData: PropTypes.func.isRequired,
  setServiceProviderData: PropTypes.func.isRequired,
  defDate: PropTypes.object.isRequired,
  setResultServiceProvider: PropTypes.func.isRequired,
  setDateServiceProvider: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: state.ServiceProviders.profileData,
  profileLoader: state.ServiceProviders.loading_profile,
  contactData: state.ServiceProviders.data,
  isError: state.ServiceProviders.isError,
  permissions: state.User.permissions,
  serviceData: state.ServiceProviders.serviceProviderWidgets,
  serviceLoader: state.ServiceProviders.serviceProviderWidgetsLoader,
  serviceProviderStats: state.ServiceProviders.serviceProviderStats,
  defDate: state.ServiceProviders.defDate,
});

export default withRouter(
  connect(mapStateToProps, {
    getServiceProviderProfile,
    updateServiceProviderProfile,
    addServiceProvider,
    setErrorServiceProviderProfile,
    getServiceProviderData,
    setServiceProviderData,
    setDateServiceProvider,
    setResultServiceProvider
  })(ServiceProvidersProfile)
);
